import styled from 'styled-components';

export const TableTotalAmountContainer = styled.div`
  margin-bottom: 16px;
`;
